import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class AdminV2ProductInformation extends Component {
  #selection = 0;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#selection++;
    document.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    super.disconnectedCallback();
  }

  #handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.product-information') || event.target.closest('product-card, dialog')) return;
    const selection = ++this.#selection;
    try {
      const { detail } = await event.promise;
      if (!detail?.html || !this.isConnected || selection !== this.#selection) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = Array.from(detail.html.querySelectorAll('admin-v2-product-information'))
        .find((element) => element.dataset.sectionId === this.dataset.sectionId);
      if (!replacement) return;
      this.dataset.productId = replacement.dataset.productId;
      morph(this, replacement, { childrenOnly: true });
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[admin-v2-product-information] Update failed:', error);
    }
  };
}

if (!customElements.get('admin-v2-product-information')) {
  customElements.define('admin-v2-product-information', AdminV2ProductInformation);
}
